import http from '@xhs/http'
import {
  RED_IMAGE_PROD_HOST,
  PROD_HOST,
  LOGAN_HOST,
  WATERMARK,
  QCLOUD_TMP,
} from '../const'

const { post, get } = http
const isProd = process.env.NODE_ENV === 'production'
const watermarkUrl = `${isProd ? RED_IMAGE_PROD_HOST : LOGAN_HOST}${WATERMARK}`
const tmpUrl = `${isProd ? PROD_HOST : LOGAN_HOST}${QCLOUD_TMP}`

export function redWatermark({
  key,
  watermark,
  dir,
  offset = 0,
}) {
  return post(watermarkUrl, {
    file_id: key,
    text: watermark,
    upload_dir: dir,
    offset,
  }, {
    withCredentials: false,
    transfrom: false,
    extractData: false,
  })
}

export function getQcloudTmpUrl(cdnUrl, { expires } = {
  expires: 20,
}) {
  return get(tmpUrl, {
    params: {
      url: cdnUrl,
      expires,
    },
  }, {
    withCredentials: false,
  })
}
